import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate, Link } from "react-router-dom";
import './ActiveList.css?v=1.0';
import { getProgramDetails, getProgramDetailsv2, ServiceResendSMS } from "../Services/Service";
import 'jquery/dist/jquery.min.js';
import DataTable from './DataTable/DataTableV1';
import { CustomLoader, decruptCipher } from "../Services/CommonLibrary"
import { Modal, Button } from "react-bootstrap";
import moment from 'moment';

const queryParams = new URLSearchParams(window.location.search);
const status = queryParams.get('status');

function ProgramDetail() {
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showSms, setShowSms] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);
    const [hiddenValue, setHiddenValue] = useState('');
    const [showColumn, setShowColumn] = useState(true);
    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [queryParams, setQueryParams] = useState({
        clear: false,
        page: 1,
        pageSize: 50,
        sortField: '',
        sortDirection: '',
        search: '',
        filterData: {
            roleFilter: '',
            statusFilter: '',
            practiceFilter: '',
            divisionFilter: '',
            smsStartFilter: '',
            smsEndFilter: '',
            activeInactiveFilter: ''
        }
    });

    var storage = JSON.parse(localStorage.getItem('programDetail')) ? JSON.parse(localStorage.getItem('programDetail')) : 0;
    let programId = storage.programId;

    var company = localStorage.getItem('company') ? localStorage.getItem('company') : 0;
    const companyId = decruptCipher(company);

    const nav = useNavigate();
    let accessFrom = localStorage.getItem('access');
    let limit = '';
    const greenIcon = "https://appcdn.goqii.com/storeimg/79066_1678703854.png";
    const redIcon = "https://appcdn.goqii.com/storeimg/93309_1678704232.png";


    const viewPopup = (encPatientId) => {
        setShowModal(true)
        setShowSms(true);
        setHiddenValue(encPatientId);
    }

    const messageClick = () => {
        ServiceResendSMS(hiddenValue)
            .then((res) => {
                setShowSms(false);
            });
    }

    useEffect(() => {
        if (companyId == 2) {
            setShowColumn(false);
        }
        fetchProgramDetailsv2(queryParams);
    }, [queryParams]);

    function formatDate(inputDate) {
        const date = new Date(inputDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const fetchProgramDetailsv2 = async (params) => {
        const PostData = {
            division: params.filterData?.divisionFilter || '',
            practice: params.filterData?.practiceFilter || '',
            status: params.filterData?.statusFilter || '',
            page: params.page,
            pageSize: params.pageSize,
            programId: params.programId,
            sortField: params.sortField,
            smsStart: params.filterData?.smsStartFilter ? formatDate(params.filterData?.smsStartFilter) : "",
            smsEnd: params.filterData?.smsEndFilter ? formatDate(params.filterData?.smsEndFilter) : "",
            sortDirection: params.sortDirection,
            search: params.search,
            companyId: params.companyId
        };
        setLoading(true);
        try {
            // const response = await getProgramDetails(PostData);
            const response = await getProgramDetailsv2(PostData);
            setData(response.data.data);
            setTotalRows(Number(response.data.total));
        } catch (error) {
            console.error('Error fetching program details:', error);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = useCallback((page, pageSize) => {
        setQueryParams(prev => ({
            ...prev,
            page: page + 1,
            pageSize
        }));
    }, []);

    const handleFilterChange = useCallback((filterData) => {
        setQueryParams(prev => ({
            ...prev,
            filterData: { ...prev.filterData, ...filterData },
            page: 1
        }));
    }, []);

    const handleSortChange = ({ field, direction }) => {
        setQueryParams(prev => ({
            ...prev,
            sortField: field,
            sortDirection: direction
        }));
    };

    const handleSearchChange = (searchTerm) => {
        setQueryParams(prev => ({
            ...prev,
            search: searchTerm,
            page: 1
        }));
    };

    const handlePageSizeChange = (newPageSize) => {
        setQueryParams(prev => ({
            ...prev,
            pageSize: newPageSize // Reset to first page on new filter
        }));
    };

    const emptyValue = <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>;

    const columnsV1 = useMemo(() => [
        { field: 'userImageUrl', label: '' },
        { field: 'fullName', label: 'Name' },
        { field: 'nhsNumber', label: 'NHS ID' },
        { field: 'email', label: 'Email' },
        { field: 'mobile', label: 'Mobile' },
        { field: 'division', label: 'Division' },
        { field: 'clinicName', label: 'Practice' },
        { field: 'doctorName', label: 'Lead Doctor' },
        { field: 'smsSentDateNew', label: 'SMS Sent' },
        { field: 'smsDeliverDate', label: 'Delivery Status' },
        { field: 'loginDate', label: 'Login Date' },
        { field: 'onboardedDate', label: 'Onboarding Date' },
        { field: 'firstConsultationDate', label: 'First consultation Date' },
        { field: 'caoachService', label: 'Coach Selected' },
        { field: 'coachFeedBackRating', label: 'Coach Feedback Rating' },
        { field: 'no_calls', label: 'No. of calls' },
        { field: 'latestcallscheduled', label: 'Latest call Date' },
        { field: 'coachingEndDate', label: 'Coaching End' }
    ], []);

    const extraColumns = useMemo(() => [
        {
            field: 'send',
            label: 'Send',
            button: true,
            omit: (accessFrom == 'superadmin' || accessFrom == 'admin') ? false : true,
            content: row => {
                return row.buttonDisplay == true && (accessFrom == 'superadmin' || accessFrom == 'admin') ?
                    <button className='btn btn-secondary btn-sm btn-edit' style={{ fontSize: '12px' }} onClick={(e) => { viewPopup(row.encPatientIdWithType); }}>{row.buttonName}</button>
                    : null
            }
        },
        {
            field: 'edit',
            label: 'Edit',
            button: true,
            omit: (accessFrom == 'superadmin' || accessFrom == 'admin') ? false : true,
            content: row => {
                return accessFrom == 'superadmin' || accessFrom == 'admin' ?
                    <Link to={`/patient-add/${row.encPatientId}`}><button className='btn btn-primary btn-sm btn-edit' style={{ fontSize: '12px' }} >Edit</button></Link>
                    : null
            }
        }
    ], []);

    // const replaceContent = useMemo(() => [
    //     {
    //         col_name: "fullName",
    //         content: row => (
    //             <div className='tdData'>
    //                 <Link to={`/profile/${row.encPatientId}`}>{row.fullName}</Link>
    //             </div>
    //         ),
    //     }
    // ], []);
    const replaceContent = useMemo(() => [
        {
            col_name: "fullName",
            content: row => (
                <div
                    className="tdData"
                    style={{
                        backgroundColor: row.status === "Inactive" ? "#ffeeee" : "#e6ffed", // Soft red for inactive, soft green for active
                        color: row.status === "Inactive" ? "red" : "green", // Text color
                        borderRadius: "4px", // Soft box effect
                        padding: "4px 8px", // Padding for better appearance
                    }}
                >
                    <Link
                        to={`/profile/${row.encPatientId}`}
                        style={{ color: "inherit", textDecoration: "none" }} // Ensure link inherits the text color
                    >
                        {row.fullName}
                    </Link>
                </div>
            ),
        },
    ], []);


    const updateColumnConditions = useMemo(() => [
        {
            condition: (column, row) => column.field === "smsSentDate",
            content: row => {
                var dateNew = row.onboardedDate !== '-' ? moment(row.onboardedDate).format('DD MMM YYYY hh:mm A') : '';
                return (
                    <div className='tdData'>
                        <img style={{ height: "12px" }} src={row.onboardedDate != '-' ? greenIcon : redIcon} /><br />
                        {row.onboardedDate != '-' ? dateNew : emptyValue}
                    </div>
                );
            }
        },
        {
            condition: (column, row) => column.field === "userImageUrl",
            content: row => <div className='tdData'><Link to={`/profile/${row.encPatientId}`}><img src={`${row.userImageUrl}`} className="user-profile-img" /></Link></div>,
        },
        {
            condition: (column, row) => column.field === "firstConsultationDate",
            content: row => {
                var dateNew = row.firstConsultationDate !== '-' ? moment(row.firstConsultationDate).format('DD MMM YYYY hh:mm A') : '';
                return (
                    <div className='tdData'>
                        <img style={{ height: "12px" }} src={row.firstConsultationDate != '-' ? greenIcon : redIcon} /><br />
                        {row.firstConsultationDate != '-' ? dateNew : emptyValue}
                    </div>
                );
            }
        },
        {
            condition: (column, row) => column.field === "onboardedDate",
            content: row => {
                var dateNew = row.onboardedDate !== '-' ? moment(row.onboardedDate).format('DD MMM YYYY hh:mm A') : '';
                return (
                    <div className='tdData'>
                        <img style={{ height: "12px" }} src={row.onboardedDate != '-' ? greenIcon : redIcon} /><br />
                        {row.onboardedDate != '-' ? dateNew : emptyValue}
                    </div>
                );
            }
        },
        {
            condition: (column, row) => column.field === "smsDeliverDate",
            content: row => {
                var smsDeliverDateNew = row.smsDeliverDate !== '-' ? moment(row.smsDeliverDate).format('DD MMM YYYY hh:mm A') : '-';
                return (
                    <div className='tdData'>
                        <img style={{ height: "12px" }} src={row.smsStatus == 'DELIVERED' ? greenIcon : redIcon} /><br />
                        {row.smsDeliverDate !== '-' ? <span style={{ color: row.smsStatus == 'DELIVERED' ? "green" : "red" }}>{smsDeliverDateNew}</span> : emptyValue}
                    </div>
                );
            },
        },
        {
            condition: (column, row) => column.field === "smsSentDateNew",
            content: row => {
                var dateNew = row.smsSentDateNew !== '-' ? moment(row.smsSentDateNew).format('DD MMM YYYY hh:mm A') : '';
                return (
                    <div className='tdData'>
                        <img style={{ height: "12px" }} src={row.smsSentDateNew !== '-' ? greenIcon : redIcon} /><br />
                        {row.smsSentDateNew !== '-' ? dateNew : emptyValue}
                    </div>
                );
            },
        },
        {
            condition: (column, row) => column.field === "loginDate",
            content: row => {
                var dateNew = row.loginDate !== '-' ? moment(row.loginDate).format('DD MMM YYYY hh:mm A') : '';
                return (
                    <div className='tdData'>
                        <img style={{ height: "12px" }} src={row.loginDate != '-' ? greenIcon : redIcon} /><br />
                        {row.loginDate != '-' ? dateNew : emptyValue}
                    </div>
                );
            }
        },
    ], []);

    return (
        <section className='projects-section data-pd' style={{ overflow: "inherit" }}>
            <div className='row'>
                <div className="FL">
                    {console.log(totalRows)}
                    <div className='table-responsive' style={{ overflowX: "inherit" }} id='modalityLifestyle'>
                        <DataTable
                            columns={columnsV1}
                            data={data}
                            totalRows={totalRows}
                            loading={loading}
                            csvName={`${storage.programName}`.replace(/ /g, "_")}
                            exportCSVValue={true}
                            title={storage.programName}
                            onPageSizeChange={handlePageSizeChange}
                            onPageChange={handlePageChange}
                            onSortChange={handleSortChange}
                            onSearchChange={handleSearchChange}
                            onFilterChange={handleFilterChange}
                            defaultPageSize={50}
                            pageSizeOptions={[25, 50, 100, 200]}
                            extraColumns={extraColumns}
                            updateColumnConditions={updateColumnConditions}
                            replaceContent={replaceContent}
                            filterStatus={true}
                            filterPractice={true}
                            filterDivision={true}
                            filterSmsDate={true}
                            showClearbtn={true}
                            showFilter={true}
                        />
                    </div>
                </div>
            </div>
            {loading ? <CustomLoader /> : null}

            {showModal ?
                <Modal dialogClassName="modal-md" show={showModal} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Send SMS</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {showSms ? <h5>Are you sure? Want to send SMS!</h5> :
                            <h5 className='text-success'>SMS Send Successfully</h5>}
                    </Modal.Body>
                    <Modal.Footer>
                        {showSms ? <Button variant="success" onClick={(e) => messageClick()} className="btn-sm">
                            Ok
                        </Button> : null}
                        <Button variant="danger" onClick={handleClose} className="btn-sm">
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                : null
            }
        </section>
    );
}

export default ProgramDetail;